import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/entrepreneurshipPageImages/2.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/FooterCard/FooterCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/VideoPlayer/VideoPlayer.tsx");
